import { LOGOUT } from '@/Graphql/mutation';
import { handleError } from '@/lib/utils';
import { authState } from '@/vars/auth';
import { useApolloClient, useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

const useLogout = () => {
  const navigate = useNavigate();
  const client = useApolloClient();
  const onLogout = () => {
    localStorage.clear();
    authState({
      authenticated: false,
      loading: false,
    });
    client.clearStore();
    client.stop();
    navigate('/login');
  };

  const [logout] = useMutation(LOGOUT, {
    onError: (err) => {
      handleError(err);
      onLogout();
    },
    onCompleted: () => {
      onLogout();
    },
  });

  return { logout, onLogout };
};

export default useLogout;
